import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import AppBadge from './app-badge'

// Yellow lock badge for a record its owner has frozen against edits. Forwards its ref and extra
// props so it can serve as an OverlayTrigger target or a button.
const LockedBadge = React.forwardRef(({ className = '', children = 'Locked', ...props }, ref) => (
  <AppBadge
    ref={ref}
    variant="warning"
    className={`d-inline-flex align-items-center gap-1 ${className}`.trim()}
    {...props}
  >
    <FontAwesomeIcon icon={faLock} />
    {children}
  </AppBadge>
))

export default LockedBadge
